export default {
  title: 'Waves',
  actions: {
    create: 'Create wave',
    delete: 'Delete wave'
  },
  steps: {
    create: 'Create a wave step',
    edited: 'Edit step'
  },
  deletion: {
    message: 'Are you sure you want to delete this wave ?'
  },
  empty: {
    title: 'No wave',
    message: 'To create a wave, noting\'s could be simple, just click on the following link:'
  },
  list: {
    name: 'name',
    status: 'status',
    who: 'who',
    where: 'where',
    when: 'when',
    reward: 'reward'
  }
}



// WEBPACK FOOTER //
// ./src/translations/en/waves.js